import React from 'react';
import { FiShield, FiUserCheck, FiLayers, FiFileText } from 'react-icons/fi'; // 1. Added FiFileText here
import { LuSparkles } from 'react-icons/lu'; // 2. Removed LuFileSignature from here
import { HiOutlineFolderAdd } from 'react-icons/hi';

const ComplianceRecordsSummary = () => {
  const records = [
    {
      label: "Opening Check Record",
      count: 1,
      icon: <FiFileText className="text-indigo-600 text-sm" />, // 3. Swapped to FiFileText here
    },
    {
      label: "Safety Observation",
      count: 1,
      icon: <FiShield className="text-indigo-600 text-sm" />,
    },
    {
      label: "Equipment Status",
      count: 3,
      icon: <FiLayers className="text-indigo-600 text-sm" />,
    },
    {
      label: "Premises Observation",
      count: 1,
      icon: <LuSparkles className="text-indigo-600 text-sm" />,
    },
    {
      label: "Staff Readiness",
      count: 1,
      icon: <FiUserCheck className="text-indigo-600 text-sm" />,
    }
  ];

  // Calculate the total records dynamically
  const totalRecords = records.reduce((sum, item) => sum + item.count, 0);

  return (
    <div className="w-full bg-white border border-slate-100 rounded-2xl p-5 shadow-sm font-sans flex flex-col">
      
      {/* Header Info Block */}
      <h3 className="text-sm font-bold text-slate-900">
        Compliance Records
      </h3>
      <p className="text-[11px] text-slate-400 font-medium leading-relaxed mt-2 mb-4">
        Records that will be generated when this check is completed.
      </p>

      {/* Main Records List Stack */}
      <div className="flex flex-col gap-3.5">
        {records.map((item, index) => (
          <div key={index} className="flex items-center justify-between text-xs font-semibold text-slate-700">
            <div className="flex items-center gap-2.5">
              {/* Icon Container */}
              <div className="shrink-0 flex items-center justify-center">
                {item.icon}
              </div>
              <span className="truncate max-w-[170px]">{item.label}</span>
            </div>
            <span className="text-slate-800 pr-1">{item.count}</span>
          </div>
        ))}

        {/* Highlighted Blue Bottom Total Row */}
        <div className="flex items-center justify-between text-xs font-bold text-indigo-600 border-t border-slate-50 pt-3.5 mt-1">
          <div className="flex items-center gap-2.5">
            <div className="shrink-0 flex items-center justify-center">
              <HiOutlineFolderAdd className="text-indigo-600 text-base" />
            </div>
            <span>Total Records</span>
          </div>
          <span className="pr-1">{totalRecords}</span>
        </div>
      </div>

    </div>
  );
};

export default ComplianceRecordsSummary;
